import { makeStyles, Text, tokens } from '@fluentui/react-components';
import { ShieldRegular } from '@fluentui/react-icons';

type Props = {
  className?: string;
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: tokens.spacingHorizontalS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    margin: `0 15px ${tokens.spacingVerticalM}`,
    backgroundColor: tokens.colorBrandBackground2,
    borderLeft: `3px solid ${tokens.colorBrandStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
  },
  icon: {
    color: tokens.colorBrandForeground1,
    fontSize: '16px',
    lineHeight: '20px',
    flexShrink: 0,
  },
  text: {
    color: tokens.colorNeutralForeground2,
    lineHeight: '20px',
  },
});

export const RetentionDisclaimer = ({ className }: Props) => {
  const styles = useStyles();
  return (
    <div className={className ? `${styles.container} ${className}` : styles.container}>
      <ShieldRegular className={styles.icon} />
      <Text size={200} className={styles.text}>
        Les enregistrements audio et transcriptions sont supprimés après 3
        mois. Les comptes-rendus sont conservés indéfiniment.
      </Text>
    </div>
  );
};
